<div class="accordion" [id]="id">
  <div class="accordion-item">
    <div class="accordion-header" id="headingOne">
      <button
        class="accordion-button"
        [ngClass]="{collapsed: this.collapsed}"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse-body"
        [attr.aria-expanded]="!collapsed"
        aria-controls="collapse-body">
        {{header}}
      </button>
    </div>
    <div
      id="collapse-body"
      class="accordion-collapse collapse"
      [ngClass]="{show: !collapsed}"
      aria-labelledby="headingOne"
      [attr.data-bs-parent]="'#'+id">
      <div class="accordion-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
